import { render, staticRenderFns } from "./de-CH.vue?vue&type=template&id=3ce984a0&"
import script from "./de-CH.vue?vue&type=script&lang=js&"
export * from "./de-CH.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ce984a0')) {
      api.createRecord('3ce984a0', component.options)
    } else {
      api.reload('3ce984a0', component.options)
    }
    module.hot.accept("./de-CH.vue?vue&type=template&id=3ce984a0&", function () {
      api.rerender('3ce984a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/Languages/de-CH.vue"
export default component.exports